<template>
  <v-dialog v-model="filter.filterDialog" persistent max-width="920">
    <template #activator="{ props }">
      <v-btn v-bind="props" color="light-green" class="text-black" @click="initLists">
        Filtros
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Filtrar Mercaderias por:</v-card-title>
      <v-card-text>
        <v-form ref="form" class="ma-2" @submit.prevent="applyFilters">
          <v-row dense>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filter.ownerId"
                label="Propietario"
                item-value="id"
                item-title="name"
                :items="companies"
                variant="outlined"
                density="comfortable"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filter.grainTypeId"
                label="Tipo de grano"
                item-value="id"
                item-title="name"
                :items="grainTypes"
                variant="outlined"
                density="comfortable"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field v-model="filter.gmgMin" type="number" step="10" label="Gramaje Min." variant="outlined" density="comfortable" />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field v-model="filter.gmgMax" type="number" step="10" label="Gramaje Max." variant="outlined" density="comfortable" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="filter.locationInPlant" label="Ubicacion en Planta" variant="outlined" density="comfortable" />
            </v-col>
            <v-col cols="12" md="4">
              <income-selector v-model="filter.incomeId"></income-selector>
            </v-col>
            <v-col cols="12" md="4">
              <process-selector v-model="filter.processId"></process-selector>
            </v-col>
            <v-col cols="12" md="4">
              <quality-type-selector v-model="qualityType"></quality-type-selector>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="filter.harvesting" label="Cosecha" variant="outlined" density="comfortable" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" variant="text" @click="clearFilters">{{ CONST.CLEAN_FILTERS }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" @click="filter.filterDialog = false">Cancelar</v-btn>
        <slot v-bind="{ filter, apply: applyFilters }"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import IncomeSelector from '../Common/IncomeSelector'
import ProcessSelector from '../Common/ProcessSelector'
import QualityTypeSelector from '../Common/QualityTypeSelector'
import CONST from '../../services/common/Constants.js'

export default {
  name: 'CommodityFilter',
  emits: ['apply'],
  components: {
    'income-selector': IncomeSelector,
    'process-selector': ProcessSelector,
    'quality-type-selector': QualityTypeSelector
  },
  data () {
    return {
      CONST: {},
      filter: {
        filterDialog: false,
        ownerId: null,
        grainTypeId: null,
        qualityTypeId: null,
        gmgMin: null,
        gmgMax: null,
        harvesting: null,
        incomeId: null,
        processId: null,
        locationInPlant: null
      },
      companies: [],
      grainTypes: []
    }
  },
  computed: {
    qualityType: {
      get () { return this.value },
      set (v) {
        this.filter.qualityTypeId = (v) ? v.id : null
      }
    }
  },

  created () {
    this.CONST = CONST
    this.initialize()
  },

  methods: {
    applyFilters () {
      this.filter.filterDialog = false
      this.$emit('apply', this.filter)
    },
    async initialize () {
      await this.$store.dispatch('companyModule/getBaseCompanies')
      this.companies = this.$store.getters['companyModule/getBaseCompanies']
      await this.$store.dispatch('typesModule/getGrainTypes')
      this.grainTypes = this.$store.getters['typesModule/getGrainTypes']
    },

    clearFilters () {
      this.$store.dispatch('incomeModule/refreshFilteredIncomes')
      this.$store.dispatch('processModule/refreshFilteredProcesses')
      this.$refs.form.reset()
    },

    async initLists () {
      await this.$store.dispatch('incomeModule/getIncomeNumberList')
      await this.$store.dispatch('processModule/getProcessNumberList')
    }
  }
}
</script>
